import React from "react";

export const CurrentWeddingUsersContext = React.createContext([]);
CurrentWeddingUsersContext.displayName = "CurrentWeddingUsersContext";

export const SetCurrentWeddingUsersContext = React.createContext(() => {});
SetCurrentWeddingUsersContext.displayName = "SetCurrentWeddingUsersContext";
